import useFlag from "@/hooks/useFlag";
import FeatureFlags from "@/utils/featureFlags";

import { ActivitiesLibraryPage } from "./ActivitiesLibraryPage";
import { ActivityCreatePage } from "./components/ActivityCreatePage/ActivityCreatePage";
import { VoiceMessagesLibrary } from "./VoiceMessageLibraryPage";

export const ActivityLibrary = () => {
  const showNewActivityLibrary = useFlag(FeatureFlags.SHOW_NEW_ACTIVITY_LIBRARY);

  return showNewActivityLibrary ? <ActivitiesLibraryPage /> : <VoiceMessagesLibrary />;
};

export { ActivityCreatePage };
